import { DataBean } from "../DataBean";

export class ModalityStage extends DataBean {



    public async getHiringModalityStageCatalog(idHiringModality: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getHiringModalityStageCatalog_Number_Number_Number", [idHiringModality, page, recordsPerPage]);
    }

}
